<!-- <app-breadcrumb [title]="'Preferences'"></app-breadcrumb> -->

<app-loader [show]="skeleton"></app-loader>
<div [class.d-none]="skeleton" class="row">
  <div class="row">
  <div class="col-md-3 bg-white rounded shadow">
    <div class="pl-3 pr-5">
      <app-navbar [step]="7">
      </app-navbar>
    </div>
  </div>
  <div class="col-md-9">
    <div class="d-flex justify-content-between align-items-center pb-2 mb-3 border-bottom">
      <h3 class="h6 fw-bold mb-0">{{ title }}</h3>
      <a [routerLink]="['/employee/transfer-request']" class="btn btn-outline-primary">Cancel</a>
    </div>
  <div class="row g-3 mb-3">
    <div class="col-3">
      <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.regionId" #regionId="ngModel"
        (change)="getStates($event.target.value)">
        <option value="" selected>--SELECT REGION--</option>
        <option *ngFor="let item of regions" [value]="item.value">{{ item.text }}
        </option>
      </select>
    </div>
    <div class="col-3">
      <button type="button" class="btn btn-success" (click)="filter()">Search</button>
    </div>
    <div class="col-6 text-end">
      <h6 class="text-danger">"Protected Deemed" is not a vacancy, hence not displayed</h6>
    </div>
  </div>
<div class="row">
  <div class="col-12 col-md-6">

    <div class="border-bottom">
      <h6 class="fw-bold">Vacant Post</h6>
    </div>



    <div *ngIf="queryResult.items" class="table-responsive">
      <table class="table align-items-center table-hover table-sm">
        <colgroup>
          <col style="width: 10%">
          <col style="width: 20%">
          <col style="width: 20%">
          <col style="width: 25%">
          <col style="width: 20%">
          <col style="width: 10%">
        </colgroup>
        <thead class="table-info">
          <tr>
            <th *ngFor="let c of columns">
              <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                <div class="d-flex justify-content-between align-items-center">
                  {{ c.title }}
                  <div class="ml-2">
                    <i *ngIf="query.sort === c.key" class="fas" [class.fa-sort-down]="query.sortDir == 'Ascending'"
                      [class.fa-sort-up]="query.sortDir == 'Descending'"></i>
                  </div>
                </div>
              </div>
              <div *ngIf="!c.isSortable">
                {{ c.title }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let v of queryResult.items; let i=index;">
            <td>{{ (queryResult.pageSize * queryResult.pageNumber + i) - 9 }}</td>
            <td>{{ v.sanctionedPost?.school?.name }}</td>
            <td>{{ v.sanctionedPost?.designation?.name }}</td>
            <td>{{ v.vacancyType?.name }}</td>
            <td>{{ v.noOfPost }}</td>
            <td>
              <button type="button" class="btn btn-success btn-sm" (click)="add(v)">
                <i-bs name="plus" width="1em" height="1em"></i-bs>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page" [page-size]="query.pageSize">
    </pagination>
  </div>

  <div class="col-12 col-md-6">
    <app-preference [preferences]="preferences" (onChangePreference)="getVacantPosts()"></app-preference>
  </div>
</div>


  <hr class="my-3" />
  <div class="col-12 d-flex justify-content-end border-top mt-3 p-3" *ngIf="!isSubmitEnable">
    <button class="btn btn-primary rounded-0" disabled>Submit</button>
  </div>
  <div class="col-12 d-flex justify-content-end border-top mt-3 p-3" *ngIf="isSubmitEnable && preferences">
    <a class="btn btn-primary rounded-0" [routerLink]="['/employee/transfer-request/view']">Submit</a>
    <!-- <a class="btn btn-primary rounded-0" (click)="save()">Submit</a> -->
  </div>

</div>
</div>
</div>
